import { DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';
import { LegacyPriceBasedSerialNumberPoolBuilder } from './legacy-price-based-serial-number-pool.js';
import { LegacyTicketBasedSerialNumberPoolBuilder } from './legacy-ticket-based-serial-number-pool.js';
import { PriceBasedSerialNumberPool } from './price-based-serial-number-pool.js';
import { TemplateBasedSerialNumberPool } from './template-based-serial-number-pool.js';

export class LegacyTicketBasedSerialNumberPoolMigratingBuilder extends DataModelBuilder<TemplateBasedSerialNumberPool> {
  private readonly legacyBuilder: LegacyTicketBasedSerialNumberPoolBuilder = new LegacyTicketBasedSerialNumberPoolBuilder();

  build(context: SerializationContext, map: SerializedData): TemplateBasedSerialNumberPool {
    const legacyPool = this.legacyBuilder.build(context, map);

    return TemplateBasedSerialNumberPool.fromLegacy(legacyPool);
  }

  onBeforeDeserialization(context: SerializationContext, map: SerializedData): void {
    this.legacyBuilder.onBeforeDeserialization(context, map);
  }

  onBeforeSerialization(context: SerializationContext, model: TemplateBasedSerialNumberPool): void {
    throw new Error('LegacyTicketBasedSerialNumberPool should not be serialized.');
  }

  migrateToCurrentSchemaVersion(context: SerializationContext, map: SerializedData): SerializedData | null {
    return this.legacyBuilder.migrateToCurrentSchemaVersion(context, map);
  }
}

export class LegacyPriceBasedSerialNumberPoolMigratingBuilder extends DataModelBuilder<PriceBasedSerialNumberPool> {
  private readonly legacyBuilder: LegacyPriceBasedSerialNumberPoolBuilder = new LegacyPriceBasedSerialNumberPoolBuilder();

  build(context: SerializationContext, map: SerializedData): PriceBasedSerialNumberPool {
    const legacyPool = this.legacyBuilder.build(context, map);

    return PriceBasedSerialNumberPool.fromLegacy(legacyPool);
  }

  onBeforeDeserialization(context: SerializationContext, map: SerializedData): void {
    this.legacyBuilder.onBeforeDeserialization(context, map);
  }

  onBeforeSerialization(context: SerializationContext, model: PriceBasedSerialNumberPool): void {
    throw new Error('LegacyPriceBasedSerialNumberPool should not be serialized.');
  }

  migrateToCurrentSchemaVersion(context: SerializationContext, map: SerializedData): SerializedData | null {
    return this.legacyBuilder.migrateToCurrentSchemaVersion(context, map);
  }
}
